import React from "react";
import CustomTextbox from "../../components/Forms/CustomInputs/CustomTextbox";
import { useSelector } from "react-redux";
import CustomDropdown from "../../components/Forms/CustomInputs/CustomDropdown";

const AddUpdateUI = ({ formik, selectedCountry, setSelectedCountry }) => {
  const { data: countries } = useSelector((state) => state.country);
  const { values, errors, handleChange, handleBlur, setFieldValue } = formik;
  return (
    <>
      <CustomDropdown
        fieldName="country"
        values={selectedCountry}
        error={errors.country}
        label={"Select Country"}
        classes={"col-md-12"}
        setFieldValue={setFieldValue}
        handleChange={(value) => setSelectedCountry(value)}
        options={
          countries
            ? countries?.map((data) => {
                return { label: data.name, value: data._id };
              })
            : []
        }
      />

      <CustomTextbox
        fieldName="name"
        value={values.name}
        error={errors.name}
        label={"State Name"}
        classes={"col-md-12"}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />

      <CustomTextbox
        fieldName="code"
        value={values.code}
        error={errors.code}
        label={"State Code"}
        classes={""}
        handleBlur={handleBlur}
        inputType={"text"}
        handleChange={handleChange}
      />
    </>
  );
};

export default AddUpdateUI;
